import React from "react";
import { Button, Switch } from "@showitinc/showit-wc";
import AppConstants from "../../constants/AppConstants";
import { initFormatter } from "../../utils/PropertyFormatters";
import { AUTO_PLAY, LOOP, MUTE, SHOW_CONTROLS } from "../../constants/VideoConstants";
import MediaSelectHandler from "../utils/MediaSelectHandler";
import AssetSelectInput from "../../app2components/panel/shared/AssetSelectInput";
import When from "../utils/When";
import DocumentStore from "../../document/DocumentStore";
import { COMMANDS } from "../../document/commands";

const { UPDATE_ACTION_DELETE, UPDATE_ACTION_SET } = AppConstants;

const VideoAssetSettings = ({ element, isLocked, onPropChange }) => {
  const elementId = element.toJS().selected.id;

  const _assetSelectionHandler = () => {
    MediaSelectHandler.selectMedia(elementId, element, { type: "video" });
  };

  const _resizeToAspectRatio = () =>
    DocumentStore.dispatch({
      type: COMMANDS.RESIZE_TO_ASPECT_RATIO,
      payload: [element, elementId, aspectRatio],
    });

  const handleAutoplayChange = (autoplayValue) => {
    if (autoplayValue === 1) {
      onPropChange({
        name: MUTE,
        value: 1,
        action: UPDATE_ACTION_SET,
      });
    }
  };

  const _onSwitch = (propInfo) => {
    const { defaultValue } = propInfo;
    const value = propInfo.value ? 1 : 0;

    onPropChange({
      ...propInfo,
      value,
      action: defaultValue === value ? UPDATE_ACTION_DELETE : UPDATE_ACTION_SET,
    });

    if (propInfo.name === AUTO_PLAY) {
      handleAutoplayChange(value);
    }
  };

  const video = element.get("content", false);
  const aspectRatio = video.get("aspect_ratio", false);

  const separatePath = (path) => path.split(".");
  const getValue = (path, fallback) => element.getIn(separatePath(path), fallback);
  const prepChange = (path, defaultValue) => [path, getValue(path), true, false, defaultValue];

  const { onChange: onSwitch } = initFormatter(_onSwitch);

  const isAutoplayEnabled = getValue(AUTO_PLAY, true);

  return (
    <div>
      <p className="instrux" style={{ fontSize: 12, marginLeft: 10, marginRight: 10 }}>
        Upload an MP4 file no larger than 8MB. For larger videos, use YouTube or Vimeo.
      </p>
      <AssetSelectInput
        label="Video"
        selectLabel="Choose Video"
        propName="content"
        assetType="video"
        value={video}
        onSelect={_assetSelectionHandler}
      />
      <When it={video?.has("key")}>
        <Button
          look="primary"
          disabled={isLocked}
          style={{ width: "100%", marginBottom: "8px" }}
          onClick={_assetSelectionHandler}
        >
          <span className="icon icon-video" style={{ fontSize: "1.2em" }} /> &nbsp;Swap Video
        </Button>
        <Button
          disabled={isLocked}
          look="secondary"
          style={{ width: "100%", marginBottom: "16px" }}
          onClick={_resizeToAspectRatio}
        >
          <span className="icon icon-resize-aspect-ratio" style={{ fontSize: "1.2em" }} />
          &nbsp;Resize To Aspect Ratio
        </Button>
      </When>
      <Switch
        checked={isAutoplayEnabled}
        disabled={isLocked}
        label="Autoplay (muted)"
        onSIChange={onSwitch(...prepChange(AUTO_PLAY, getValue(AUTO_PLAY, 1)))}
        reserveContext
      />
      <Switch
        checked={getValue(SHOW_CONTROLS, false)}
        disabled={isLocked}
        label="Show Controls"
        onSIChange={onSwitch(...prepChange(SHOW_CONTROLS, getValue(SHOW_CONTROLS, 0)))}
        reserveContext
      />
      <Switch
        checked={getValue(LOOP, true)}
        disabled={isLocked}
        label="Loop"
        onSIChange={onSwitch(...prepChange(LOOP, getValue(LOOP, 1)))}
        reserveContext
      />
      <Switch
        checked={getValue(MUTE, true)}
        disabled={isLocked || isAutoplayEnabled}
        label="Mute"
        onSIChange={onSwitch(...prepChange(MUTE, getValue(MUTE, 1)))}
        reserveContext
      />
    </div>
  );
};

export default VideoAssetSettings;
